module.exports = __webpack_public_path__ + "static/volkslift-423bfe2f7927f8adf84f103ca0b3219b.png";